import {React,useEffect,useState,useContext} from 'react'
import axios from "axios";
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from "../../../App";
import {API_URL}  from '../../../Constant';
import {BlockASheet} from '../../../Custom/ASIReport/PendencyReport/ExportaPendencyReportExcel';
import {changeDateFormat, validateASIReportsRole,getNextYear} from "../../../Custom/Custom";
import titlesData from '../../../titles.json';
import { jwtDecode } from 'jwt-decode';
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../assets/Messages.json';
import asiTitle from '../../../asi.json';


function BlockAReport() {

  const currentDate = new Date();
  const prevMonthDate = new Date(currentDate);
  prevMonthDate.setMonth(currentDate.getMonth() - 1);
  const prevMonthName = prevMonthDate.toLocaleString('default', { month: 'short' }).toUpperCase();
  const storedLanguage = localStorage.getItem('language');
  const [year,setYear]=useState([]);  
  const [yearName, setYearName] = useState('');
  const [surveyYearRang,setYearNameNext]=useState([]);
  const [yearNameNextTitle,setYearNameNextTitle]=useState([]);
  const [division,setdivision]=useState([]);
  const [divisionName,setdivisionName]=useState([]);
  const [district,setdistrict]=useState([]);
  const [districtName,setdistrictName]=useState([]);
  const [monthName,setMonthName]=useState(prevMonthName);
  const [divisionList,setDivisionList]=useState([]);
  const [districtList, setDistrictList] = useState([]);

  const [asiPendingDSLNOReport, setasiPendingDSLNOReport] = useState([]);


 

  const token=useContext(MyContextProvider).token;
  const navigate = useNavigate();

  const config = {
      headers: {
          Authorization: `Bearer ${token}`,
      },
    };


    const userLevel = jwtDecode(token).id.USER_TYPE;
    const userlevelLogin = jwtDecode(token).id.USER_LEVEL_LOCATION;
    const userlevelLoginName = jwtDecode(token).id.LOCATION_NAME;



useEffect(() => { //Get all Years Data
    const userRole = async () => {
      showLoading(true)
      try {
        const role = await validateASIReportsRole(jwtDecode(token));
        if (!role) {
          alert("You are not an authorized for ASI Report");
          navigate("/dashboard");
        } 
      } catch (error) {
        console.log(error);
        showLoading(false)
      }
    }


     // All Division  list
      const fetchDivisionList = async () => {
        try {
           const response = await axios.get(`${API_URL}api/getalldivisionallist`, config);
           const allDivision = response.data;
  
          if (allDivision.status) {
            setDivisionList(allDivision.data);
            showLoading(false);
          }
        } catch (error) {
          console.error(error);
          showLoading(false);
        }
      };

      if (userLevel === "HEAD QUARTER") {
       getallDistrictList();
      }

     
      userRole();
      fetchDivisionList();
      getSurveyYears()

}, []);


  //get Years 
  const getSurveyYears=async()=>{
    showLoading(true)
       try {
          const response = await axios.get(`${API_URL}api/asi/surveyYearList`, config);
          const allYear = response.data;
          if (allYear.status) {
              setYear(allYear.data.surveyYearList.reverse())
              showLoading(false);
          }
    } catch (error) {
       console.error(error);
       showLoading(false);
    }finally{
       showLoading(false);
    }
  
  }
   

const getallDistrictList = async () => {
  try {
        const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
        const allDistrictsHQ = response.data;
        setDistrictList(allDistrictsHQ.data); 
    } catch (error) {
        console.error(error);
    }
};





  const handleSubmit = async (event) => {
    event.preventDefault(); 

    
    if (!yearName) {
      toast.error('Please Select Survey Year', messages.COLOR_RED);
      return;
    }

    let modifiedDivision = division;
    let modifiedDistrict = district;


    if (Array.isArray(division) && division.length === 0) {
      modifiedDivision = "";
    }
    if (Array.isArray(district) && district.length === 0) {
      modifiedDistrict = "";
    }

    if(modifiedDivision === "00" || modifiedDistrict ==="00"){
      toast.info('Data not found.', messages.COLOR_RED);
      setasiPendingDSLNOReport([]);
      return false;
    }

    
    const post_data = {
      "survey_year": yearName,
      "division_code": modifiedDivision,
      "district_code": modifiedDistrict
    };

    try {

      showLoading(true);

      const response = await axios.post(`${API_URL}api/asi/reports/FilledReports/asiFilledDSLReport`, post_data, config);
     const filledDslData = response.data;
      if (filledDslData.status) {
        handleGenerateExcel(filledDslData.data.asiFilledReport,post_data);
        showLoading(false);
      }else{
        toast.error('data is not Found', messages.COLOR_RED);
      }
    } catch (error) {
      console.error(error);
      showLoading(false);
    }


  };

  const handleYearChange = (event) => {
      setYearName(event.target.value);
      const selectedYear = parseInt(event.target.value);
      if (!isNaN(selectedYear)) {
        const nextYear = selectedYear + 1;
        setYearNameNext(`${selectedYear}_${nextYear}`);
        setYearNameNextTitle(`${selectedYear}-${nextYear}`);
      }
      
  };


  //DownLoad Excel sheet *************
const handleGenerateExcel = async (filledDslData,post_data) => {



  let excelFileName = "FilledDSLReport";

  // if (typeof divisionName === "string" && divisionName !== "") {
  //   excelFileName = `${excelFileName}_${divisionName.replace(" ", "_")}`;
  // }
  // if (typeof districtName === "string" && districtName !=="") {
  //   excelFileName = `${excelFileName}_${districtName.replace(" ", "_")}`;
  // }
  // if (typeof yearName === "string" && yearName !=="") {
  //   excelFileName = `${excelFileName}_${surveyYearRang.replace(" ", "_")}`;
  // }

  const excelObjectData = {
    fileName: excelFileName,
    reportType: excelFileName,
    fileType: 'xls',
    sheetName: 'BlockA',
    firstRowMergeCells: "A1:M1",
    firstRowExportDate:  changeDateFormat(new Date()),
    secondRowMergeCells: "A2:M2",
    secondRowText: `Annual Survey of Industries, Uttar Pradesh`,
    thirdRowMergeCells: "A3:M3",
    thirdRowText: `Block 'A':Identification particulars`,
    headerEnglishColumns: [
      'REGION NAME', 'DIVISION NAME','DISTRICT NAME', 'DSL_NO', 
      'SURVEY YEAR','PSL_NO', 'SCHEME CODE', 'NIC CODE PERRETURN',
      'SECTOR', 'NUMBER_OF_UNIT','STATUS_OF_UNITCODE','SUBMITED DATE','REASON']
 };

 const transformedData = filledDslData.map(item => {
    // Format submitDate from DD-MM-YYYY to DD/MM/YYYY
    let formattedSubmitDate = '';
    if (item.submitDate) {
      const dateParts = item.submitDate.split("-");
      if (dateParts.length === 3) {
        formattedSubmitDate = `${dateParts[0]}/${dateParts[1]}/${dateParts[2]}`;
      } else {
        formattedSubmitDate = item.submitDate;
      }
    }
    
    return [
      item.regionName,
      item.divisionName,
      item.districtName,
      item.dsl_No,
      `${(item.surveyYear!=='')? getNextYear(item.surveyYear):''}`,
      item.psl_No,
      item.schemeCode,
      item.nicCodePerreturn,
      item.sector,
      item.number_Of_Unit,
      item.status_Of_Unitcode,
      formattedSubmitDate,
      getReason(item.reason)
    ];
  });

  excelObjectData.excelRowData = transformedData;
 BlockASheet(excelObjectData)


}

const getReason=(type)=>{
let mess='';
  switch (type){
    case 1:
      mess="Factory is Denied for data"
      break;
    case 2:
      mess="Factor is unable to data"
      break;
    case 3:
      mess="Factory is asking help"
      break;
    case 0:
      mess=""
      break;
    default:
      mess=""
  }
  return mess;
  
}






  return (
    <>
    <ToastContainer />
    <GlobalLoading />

 <div className="container-fluid py-3">
     <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
          <div className="row align-items-center">
           <h4 className="page_heading">

           <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.BLOCK_A_REPORT : asiTitle.en.BLOCK_A_REPORT }} />
           </h4>
           <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
           <label>{storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}</label>
               
              <select
                  name="yearName"
                  className="form-select"
                  onChange={handleYearChange}
                  value={yearName}
                 >
                  <option value="" disabled>
                    Select Year
                  </option>
                    {year
                      .sort((a, b) => b - a) 
                      .map((yearName, index) => (
                        <option key={index} value={yearName}>
                          {yearName}-{(parseInt(yearName) + 1).toString().slice(2)}
                        </option>
                    ))}
                </select>
          </div>
          <div className="col-xl-2 col-lg-12 mb-3">
             <label className="w-100 d-none d-sm-block">&nbsp;</label>
             <button onClick={handleSubmit} type="submit" className="btn btn_orange">Search</button>
         </div>
        </div>
      </div> 
     </div>
</div>
 
 </>
  )
}

export default BlockAReport